module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMS4yOSAxOS4yMyI+Cgk8ZGVmcz4KCQk8c3R5bGU+CgkJCS5jbHMtMXtmaWxsOiMwMDA7fQoJCTwvc3R5bGU+Cgk8L2RlZnM+Cgk8ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj4KCQk8ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEiPgoJCQk8cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0yMS4yOSw5LjU5bC03LjIzLDkuNjRIOS42NGw3LjA4LTkuNjRMOS42NCwwaDQuNDJabS05LjY0LDBMNC40MiwxOS4yM0gwTDcuMDgsOS41OSwwLDBINC40MloiIC8+CgkJPC9nPgoJPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/svg-img/left-black-arrow.svg
// module id = 1082
// module chunks = 4